import React from "react";
import { Tooltip, IconButton } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const ForecastDeliveryInfoTooltip = () => {
  return (
    <Tooltip
      title={
        <span>
          <strong>Note:</strong> Forecast delivery quantities are indicative
          and may not be fully accurate. Values may show both pre-adjustment
          and post-adjustment quantities. Due to calendar and transportation
          lead-time calculations, some quantities may appear shifted or
          accumulated across weeks.
        </span>
      }
      arrow
      placement="top"
      slotProps={{
        tooltip: {
          sx: {
            backgroundColor: "#000",
            color: "#fff",
            fontSize: "13px",
            lineHeight: 1.5,
            maxWidth: "380px",
            padding: "10px 12px",
          },
        },
        arrow: {
          sx: {
            color: "#000",
          },
        },
      }}
    >
      <IconButton
        size="small"
        sx={{
          marginLeft: "10px",
          padding: 0,
          color: "#000",

          "&:hover": {
            backgroundColor: "transparent !important",
            color: "#000 !important",
          },

          "&:focus": {
            backgroundColor: "transparent !important",
            color: "#000 !important",
          },
        }}
      >
        <InfoOutlinedIcon
          sx={{
            fontSize: 18,
            color: "#000",
          }}
        />
      </IconButton>
    </Tooltip>
  );
};

export default ForecastDeliveryInfoTooltip;